import PxToast from './PxToast.vue';
import { toastBus, generateId } from './utils.js';

const Toasts = {
  install(Vue) {
    const notify = params => {
      const id = generateId();
      toastBus.$emit('add', { ...params, id });
      return id;
    };

    const updateToast = patch => {
      toastBus.$emit('update', patch);
    };

    Vue.prototype['$notify'] = notify;
    Vue['notify'] = notify;
    Vue.prototype['$updateToast'] = updateToast;
    Vue['updateToast'] = updateToast;

    Vue.component(PxToast.name, PxToast);
  },
};

export default Toasts;
